
<script>
import { flip } from 'svelte/animate';
import { createEventDispatcher } from 'svelte';
import { trans } from '@/utils';

export let cities = [];
export let principles = [];
export let active = [];

export let by = 'name';

let citiesSorted = [];

const sortBy = (cities, concept)  => {
    if (concept === 'name') {
        cities.sort(function(a, b) {
            const nameA = a.name.toUpperCase();
            const nameB = b.name.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    } else if (concept === 'population') {
        cities.sort(function(a, b) {
            return b.population - a.population;
        });
    } else if (concept === 'num_projects') {
        cities.sort(function(a, b) {
            return b.projects.length - a.projects.length;
        });
    }
    return cities;
};

$: activePrinciples = principles.filter(p => active.includes(p.id));

$: stats = cities.reduce((pre, cur) => {
  if (!(cur.id in pre)) pre[cur.id] = {};
  cur.projects.forEach(project => {
    project.principles.forEach(principle => {
      if (!(principle in pre[cur.id])) pre[cur.id][principle] = 1;
      else pre[cur.id][principle]++;
    });
  })
  return pre;
}, {});

$: citiesSorted = sortBy(cities, by);

let listDiv;

const changeOrder = (concept) => {
  listDiv.scrollTop = 0;
  by = concept;
}

const dispatch = createEventDispatcher();

</script>
<div class="fl_infolist" bind:this={listDiv}>
  <div class="container">

    <div class="city_order d-none d-xl-block">
      <p class="mb-1 fs-5">{trans('sort_by')}</p>
      <div class="mb-1">
        <button type="button" class="btn btn-link p-0 border-0 text-white text-decoration-none fw-light small" class:active={by === 'name'} on:click={() => { changeOrder('name') }}>
          <i class="fa-light fa-arrow-right-long"></i>
          {trans('sort_by_name')}
        </button>
      </div>
      <div class="mb-1">
        <button type="button" class="btn btn-link p-0 border-0 text-white text-decoration-none fw-light small" class:active={by === 'population'} on:click={() => { changeOrder('population') }}>
          <i class="fa-light fa-arrow-right-long"></i>
          {trans('sort_by_population')}
        </button>
      </div>
      <div class="mb-1">
        <button type="button" class="btn btn-link p-0 border-0 text-white text-decoration-none fw-light small" class:active={by === 'num_projects'} on:click={() => { changeOrder('num_projects') }}>
          <i class="fa-light fa-arrow-right-long"></i>
          {trans('sort_by_number')}
        </button>
      </div>
    </div>

    <div class="city_wrap">
      <div class="city_item lh-sm">
        <div class="row g-0">
            <div class="col-6">
            </div>
            <div class="col-6 position-relative">
              <div class="v_bars">
                <div class="row g-0 text-end">
                  <div class="col-3 position-relative">
                    <div class="numero_pipe">25</div>
                    <i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3 position-relative">
                    <div class="numero_pipe">50</div>
                    <i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3 position-relative">
                    <div class="numero_pipe">75</div>
                    <i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3 position-relative">
                    <div class="numero_pipe">100</div>
                    <i class="fa-regular fa-pipe"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      {#each citiesSorted as city (city.id)}
        <div class="city_item lh-sm" animate:flip="{{ duration: d => Math.pow(d, 0.3) * 160 }}">
          <div class="row g-0">

            <div class="col-6">
              <div class="fs-4">
                <span class="cursor-pointer" on:click={() => { dispatch('selected', city.id) }}>{city.name}</span>
              </div>
              <div class="small text-white-50">
                {city.projects.length} {city.projects.length == 1 ? trans('1_initiative') : trans('n_initiatives')}
              </div>
            </div>
            <div class="col-6 position-relative">
              {#each activePrinciples as pri (pri.id)}
              {@const num = stats[city.id][pri.id] || 0}
              {@const percent = Math.round(num/city.projects.length*100)}
              {@const unit = num == 1 ? trans('1_initiative') : trans('n_initiatives')}
              <div data-tooltip="{ num ? `${pri.name}: ${num} ${unit} (${percent}%)` : pri.name}">
              <div class="progress rounded-pill mb-1" style="height: 8px;">
                <div class="progress-bar rounded-pill" role="progressbar" style="width:{percent}%;background:{pri.color}" aria-valuenow="{percent}" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              </div>
              {/each}
              <div class="v_bars">
                <div class="row g-0 text-end">
                  <div class="col-3"><i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3"><i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3"><i class="fa-regular fa-pipe"></i></div>
                  <div class="col-3"><i class="fa-regular fa-pipe"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/each}
    </div>

  </div>
</div>
